var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{staticClass:"text-h6 mx-1 mb-3",class:_vm.darkMode ? '' : 'mt-1',staticStyle:{"width":"61.6vw"},attrs:{"data-testid":"header"}},[_vm._v("\n    Payment Review\n  ")]),_c('unit-plan-summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }